import styled from 'styled-components';

const StyledJoinClubHeader = styled.div`
  /* background: #efefef; */
  box-sizing: border-box;
  margin: -0.5em auto 0 auto;
  padding: 0;
  height: auto;
  min-height: 15.5vh;
  font-family: 'Playfair Display', serif;

h2.header-text {
    font-size: 2.2em;
    color: #9c7456;
    text-align: center;
    letter-spacing: 0.025em;
}

.stepped-progress-bar {
  display: flex;
  justify-content: space-evenly;
  font-size: 1.35ch;
  margin: -1em auto;
  max-width: 88vw;
  font-family: sans-serif;
  cursor: pointer;
}
.stepped-item-container {
  width: 100%;
  text-align: center;
}
.stepped-item-container:nth-child(1) {
  filter: saturate(0.5);
  width: 100%;
  text-align: center;
}
.stepped-item-1 {
  letter-spacing: 0.02em;
}

/* active highliights */


.grey-border {
  border-bottom: 3px inset rgba(150,150,150,0.32);
}

.active-border {
  border-bottom: 3px inset #8C683C;
}

.active-color {
  color: #8C683C;
  font-weight: bold;
}

.item-bar {
  margin-top: 0.5em;
}

@media screen and (min-width: 600px){
  max-width: 1000px;
  zoom: 1.1;
}


`;

export default StyledJoinClubHeader